








































































































import { Component, Vue } from 'vue-property-decorator'
import { getGoonsAnnouncementList, deleteGoonsAnnouncement, updateGoonsAnnouncementStatus } from '@/api/goonsAnnouncement'

@Component({
  name: 'GoonsAnnouncementManage'
})
export default class GoonsAnnouncementManage extends Vue {
  private tableData = []

  created() {
    this.init()

    // 监听路由参数，处理从编辑页返回的刷新请求
    if (this.$route.query.refresh === 'true') {
      this.init()
    }
  }

  private async init() {
    await getGoonsAnnouncementList()
      .then(res => {
        if (res && res.data && res.data.code === 1) {
          this.tableData = res.data.data || []
        } else {
          this.$message.error(res.data.msg || '获取打手公告列表失败')
        }
      })
      .catch(err => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  private addAnnouncementHandle(st: any) {
    if (st === 'add') {
      this.$router.push({ path: '/goons-announcement/add' })
    } else {
      this.$router.push({ path: '/goons-announcement/add', query: { id: st.id } })
    }
  }

  private deleteHandle(id: any) {
    this.$confirm('确定删除该打手公告?', '确定删除', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleteGoonsAnnouncement(id)
        .then(res => {
          if (res.data.code === 1) {
            this.$message.success('删除成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg || '删除失败')
          }
        })
        .catch(err => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  private toggleStatus(row: any) {
    const newStatus = String(row.status) === '1' ? '0' : '1'
    const statusText = newStatus === '1' ? '启用' : '禁用'
    
    this.$confirm(`确定${statusText}该打手公告?`, `确定${statusText}`, {
      confirmButtonText: statusText,
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      updateGoonsAnnouncementStatus(row.id, newStatus)
        .then(res => {
          if (res.data.code === 1) {
            this.$message.success(`${statusText}成功！`)
            this.init()
          } else {
            this.$message.error(res.data.msg || `${statusText}失败`)
          }
        })
        .catch(err => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  private formatTime(time: string) {
    if (!time) return ''
    const date = new Date(time)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hour = String(date.getHours()).padStart(2, '0')
    const minute = String(date.getMinutes()).padStart(2, '0')
    return `${year}-${month}-${day} ${hour}:${minute}`
  }
}
